import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import {buildPath} from "../../utils";

const DonorRoute = () => {
    if (!sessionStorage.getItem("newDonorInfo")) {
        return <Navigate to={buildPath("/donatore")} />;
    }
    return <Outlet />;
};

export default DonorRoute;
